<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/cash')"
      />
      <div class="big_tit">
        {{ $t('account.addAccount') }}
      </div>
    </div>
    <div class="wrap_box warp1">
      <div class="item">
        <div class="ari_font">
          {{ $t('invest_bank.bank') }}：
        </div>
        <input
          v-model="bank.bank"
          type="text"
          :placeholder="$t('invest_bank.bankin')"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('account.branch') }}：
        </div>
        <input
          v-model="bank.area"
          type="text"
          :placeholder="$t('account.branchin')"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('invest_bank.account') }}：
        </div>
        <input
          v-model="bank.card"
          type="text"
          :placeholder="$t('invest_bank.accountin')"
        >
      </div>
    </div>
    <div
      class="basic_btn"
      @click="submitBtn"
    >
      {{ $t('account.submit') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'

    export default {
        name: "Account",
        data() {
            return {
                bank: {
                    card: '',
                    area: '',
                    bank:'',
                },
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            submitBtn(){
				if (!this.bank.bank.replace(/\s/g, "")) {
				    this.$notify(this.$t('invest_bank.bankin'));
				    return;
				}
				if (!this.bank.card.replace(/\s/g, "")) {
				    this.$notify(this.$t('invest_bank.accountin'));
				    return;
				}
                Fetch('/user/bank_add',{
                    ...this.bank
                }).then(r=>{
                    this.$toast({
                    	background: '#07c160',
						message: this.$t('account.success')
                    });
                    this.$router.push('/account');
                })
                
            },
            start(){}
        }
    };
</script>

<style lang="less" scoped>
    /deep/ .van-dropdown-menu {
        position: relative;
        z-index: 10;
        color: #CCCCCC;
    }

    /deep/ .van-dropdown-menu__bar {
        position: relative;
        z-index: 10;
        width: 211px;
        height: 34px;
        border: 1px solid #D9D9D9;
        border-radius: 4px;
        text-align: left;
    }

    /deep/ .van-dropdown-item--down {
        width: 211px;
        margin: 0 auto;
        z-index: 12;
        transform: translateX(4px);
    }

    /deep/ .van-dropdown-menu__item {
        justify-content: flex-start;
        color: #ccc;
        background-color: #fff;
    }

    /deep/ .van-dropdown-menu__title {
        width: 100%;
    }

    /deep/ .van-dropdown-menu__title::after {
        width: 13px;
        height: 22px;
        transform: none;
        background: url(../../assets/images/drop.png) no-repeat center center;
        background-size: 100% 100%;
        border: none;
        opacity: 1;
        margin-top: -11px;
        right: 10px;
    }

    /deep/ .van-cell {
        padding: 5px 8px;
    }

    /deep/ .van-cell__title {
        flex: 3;
        white-space: normal;
    }

    /deep/ .van-ellipsis {
        color: #000;
    }

    /deep/ .van-dropdown-item__option {
        color: #ccc;
        border: 1px solid #D9D9D9;
        border-bottom: none;
        border-radius: 4px;
    }

    /deep/ .van-dropdown-item__option:last-child {
        border-bottom: 1px solid #D9D9D9;
    }

    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
        color: #000;

        .van-dropdown-item__icon {
            color: #E96259;
        }
    }

    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
        margin-top: 12px;

        .item {
            height: 50px;
            padding: 0 16px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }

            input {
                line-height: 14px;
            }
        }
    }

    .ari_font {
        width: 70px;
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .basic_btn {
        margin: 75px auto 0 auto;
    }

    /* Ivory, champagne-gold and rose-wine account form theme. */
    .recharge_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); }
    .red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }
    .red_top_bg .big_tit, .red_top_bg .back_left { color: #8f251d; }
    .warp1 { margin: 16px 14px 0; padding: 0 14px; overflow: hidden; border: 1px solid rgba(190, 139, 52, .52); border-radius: 14px; background: rgba(255, 254, 249, .95); box-shadow: 0 9px 18px rgba(126, 84, 29, .09); }
    .warp1 .item { padding: 0 2px; border-bottom-color: rgba(190, 139, 52, .24); }.ari_font { color: #533126; }.warp1 .item input { min-width: 0; flex: 1; color: #533126; font-size: 14px; }.warp1 .item input::placeholder { color: #9c8068; }
    .basic_btn { width: calc(100% - 28px); height: 48px; margin: 28px 14px 0; border: 1px solid #b9802e; border-radius: 12px; background: linear-gradient(105deg, #a6233d, #ca5a5b); color: #fff9ea; font-size: 14px; line-height: 46px; box-shadow: 0 9px 20px rgba(151, 17, 56, .18); }
</style>
